import { createClient, type SupabaseClient } from '@supabase/supabase-js';
let client: SupabaseClient | null | undefined;
export function getSupabase(): SupabaseClient | null {
  if (client !== undefined) return client;
  const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
  const key = import.meta.env.VITE_SUPABASE_KEY as string | undefined;
  client = url && key ? createClient(url, key) : null;
  return client;
}

const pending = new WeakMap<SupabaseClient, Promise<string | null>>();

async function resolveSession(c: SupabaseClient): Promise<string | null> {
  try {
    const { data } = await c.auth.getSession();
    if (data.session) return data.session.user.id;
    const { data: anon, error } = await c.auth.signInAnonymously();
    return error ? null : anon.user?.id ?? null;
  } catch { return null; }
}

/** Identifiant de l'utilisateur (connexion anonyme au besoin). Les appels concurrents partagent la même promesse : un seul `signInAnonymously` ; elle est libérée dès qu'elle est réglée (un échec n'est pas mémorisé). */
export function ensureSession(c: SupabaseClient): Promise<string | null> {
  const running = pending.get(c);
  if (running) return running;
  const p = resolveSession(c).finally(() => { if (pending.get(c) === p) pending.delete(c); });
  pending.set(c, p);
  return p;
}
